import React, { useState } from "react";

interface AssetPreviewProps {
  audioFile: File;
}

export const AssetPreview: React.FC<AssetPreviewProps> = ({
  audioFile,
}) => {
  const [audioSrc, setAudioSrc] = useState<string | null>(null);

  React.useEffect(() => {
    if (audioFile) {
      const audioUrl = URL.createObjectURL(audioFile);
      setAudioSrc(audioUrl);
      return () => URL.revokeObjectURL(audioUrl);
    }
  }, [audioFile]);

  return (
    <>
      {audioSrc && (
        <div className="pt-2 pb-2">
          <audio
            controls={true}
            controlsList="nodownload"
            src={audioSrc}
            className="w-full"
          >
            <source src={audioSrc} type={audioFile.type} />
            Your browser does not support the audio tag.
          </audio>
        </div>
      )}
    </>
  );
};
